import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    tokenLoad: false
  },
  mutations: {
    setTokenLoad: (state, payload) => {
      state.tokenLoad = payload
    }
  }
})
